import { Grid, ThemeSpaceVariable } from "@caspeco/casper-ui-library";

export const TIME_SLOT_GRID_COLUMN_COUNT = 4;

interface ITimeSlotGrid {
    items: JSX.Element[];
    pt?: ThemeSpaceVariable;
}

const TimeSlotGrid = ({ items, pt = ThemeSpaceVariable.None }: ITimeSlotGrid) => {
    return (
        <Grid
            templateColumns={`repeat(${TIME_SLOT_GRID_COLUMN_COUNT}, minmax(0, 1fr))`}
            gap={ThemeSpaceVariable.Small}
            pt={pt}
        >
            {items}
        </Grid>
    );
};

export default TimeSlotGrid;
